import { PAGE_CHANGE } from "./actionTypes";

export const changePage = (page) => (dispatch) => {
  dispatch({ type: PAGE_CHANGE, payload: page });
};
